export default "__VITE_ASSET__BNSLlcXF__"